import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'checkbox-cell-renderer',
    template: `<input type="checkbox" style="width: 20px;height: 20px;vertical-align: middle;" [checked]="params.value" (change)="onChange($event)">`,
    standalone: false
})
export class CheckboxCellRenderer implements ICellRendererAngularComp {

	public params: ICellRendererParams;
	fieldName;
	constructor() { }

	agInit(params: ICellRendererParams): void {
		this.params = params;
		this.fieldName = this.params.colDef.field;
	}

	public onChange(event) {
		if (this.fieldName == 'completed' || this.fieldName == 'ignored') {  // NOSONAR
			this.params.data[this.params.colDef.field] = event.currentTarget.checked;
			this.params.context.componentParent.onCheckBoxSelectionChanged(this.params.data, this.fieldName);
		}
	}

	refresh(_params: ICellRendererParams): boolean {
		return true;
	}
}